import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import CommonProcessing from 'react-mt-bootstrap/lib/components/Processing/Processing'
import styles from './LoadingScreen.scss'
const LoadingScreen = ({ type }) => {
    let className = styles.base
    if (type) className += ` ${styles[`base__${type}`]}`
    return (
    <div className={className}>
      <CommonProcessing
          type="local"
          caption={
          <FormattedMessage
              id="loading_screen.caption"
              description="Текст над спиннером на экране загрузки"
              defaultMessage="Загрузка содержимого..."
          />
        }
          isVisible
      />
    </div>
    )
}
LoadingScreen.propTypes = {
    type: PropTypes.oneOf(['gamefield', 'fullscreen', 'window']),
}
export default LoadingScreen



// WEBPACK FOOTER //
// ./components/LoadingScreen/LoadingScreen.jsx